import { defineStore } from 'pinia';
import { ref } from 'vue';
import { fetchWrapper } from '@/fetch-wrapper';

const baseUrl = process.env.VUE_APP_API_BASE_URL;

export const useAuthStore = defineStore('auth', () => {
    const authInfo = ref(JSON.parse(localStorage.getItem('auth-info')));
    const user = ref(JSON.parse(localStorage.getItem('user')));
    const returnUrl = ref(null);

    async function login(email, password) {
        const result = await fetchWrapper.post(`${baseUrl}/login`, { email, password });
        authInfo.value = result;
        localStorage.setItem('auth-info', JSON.stringify(result));

        const userResult = await fetchWrapper.get(`${baseUrl}/gebruikers/${encodeURIComponent(email)}`);
        userResult.lastRetrieved = new Date();
        user.value = userResult;
        localStorage.setItem('user', JSON.stringify(userResult));
    }

    async function refressAccessToken() {
        const body = {
            "refreshToken": authInfo.value.refreshToken
        };
        const result = await fetchWrapper.post(`${baseUrl}/refresh`, body);
        authInfo.value = result;
        localStorage.setItem('auth-info', JSON.stringify(result));
    }

    function logout() {
        authInfo.value = null;
        localStorage.removeItem('auth-info');
        user.value = null;
        localStorage.removeItem('user');
    }

    return {
        authInfo,
        user,
        returnUrl,
        login,
        refressAccessToken,
        logout
    };
});